
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stories/global-citizens",
      function () {
        return require("private-next-pages/stories/global-citizens.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stories/global-citizens"])
      });
    }
  